const GLOBAL_QUERY_KEYS = {
  MAP: {
    telematics: ["map", "telematics"],
  },
  PRECISION_FARMING: {
    root: {
      ALL: ["precision-farming"],
      INTEGRATIONS: ["precision-farming", "integrations"],
      PARCEL: ["precision-farming", "parcel"],
      REPORTS: ["precision-farming", "reports"],
    },
    NITROGEN: ["precision-farming", "parcel", "nitrogen"],
    DASHBOARD: ["precision-farming", "dashboard"],
    SERVICES: ["precision-farming", "services"],
    YIELD_MAPS: ["precision-farming", "yield-maps"],
    SERVICE_GUARD: ["precision-farming", "service-guard"],
    PARCEL_IMPORT: ["precision-farming", "parcel-import"],
    PRESCRIPTION_MAPS: ["precision-farming", "prescription-map"],
  },
  CATALOGUES: {
    SHARED: ["catalogues"],
    CROPS: ["catalogues", "crops"],
    SEEDS: ["catalogues", "seeds"],
    FERTILIZERS: ["catalogues", "fertilizers"],
    PLANT_PROTECTION: ["catalogues", "plantProtection"],
    MACHINES: ["catalogues", "machines"],
    DRIVERS: ["catalogues", "drivers"],
    EQUIPMENT: ["catalogues", "equipment"],
  },
  TELEMATICS: {
    MACHINES: ["telematics", "machines"],
    LOGBOOK: ["telematics", "logbook"],
    ADVANCED_FILTER: ["telematics", "advanced-filter"],
    DRIVE_KEY: ["telematics", "keys"],
    WINFAS_CLIENT: ["telematics", "winfas", "clients"],
    DRIVERS: ["telematics", "drivers"],
    RULES: ["telematics", "rules"],
    HANDWORK: ["telematics", "handwork"],
    IMPORT_HISTORY: ["telematics", "import-history"],
    CUSTOMER_KEY_CALCULATION: ["telematics", "customer-key-calculation"],
  },
  ADMIN: {
    MANAGER: {
      FARMS: ["admin", "manager", "farms"],
      SENTINEL: ["admin", "manager", "sentinel"],
    },
    IMPERSONATION: ["admin", "impersonation", "all-farms"],
  },
  CORE: {
    PRECISION: {
      DETAIL: ["core", "precision", "detail"],
      BIOMONITORING: ["core", "precision", "biomonitoring"],
      SOIL_SAMPLES: ["core", "precision", "soil-samples"],
      YIELD_MAPS: ["core", "precision", "yield-maps"],
      AGRODATA: ["core", "precision", "agrodata"],
    },
    USER: {
      INTEGRATIONS: ["core", "user", "integrations"],
    },
  },
  STORES: ["stores"],
  REPORTS: ["reports"],
  SHARED: {
    AGROEVIDENCE: {
      SEED_APPLICATIONS: ["shared", "agroevidence", "seed-aplications"],
      SUBTRACTABLE_AREAS: ["shared", "agroevidence", "vegetation-strips"],
    },
  },
};

export { GLOBAL_QUERY_KEYS };
